// client/extensions/starterPack.ts
import { Spacer } from "./ActionbarSpacer.js";
import { Bold } from "./Bold.js";
import { BulletList } from "./BulletList.js";
import { CodeBlock } from "./CodeBlock/CodeBlock.js";
import { Color } from "./Color.js";
import { Document } from "./Document.js";
import { Dropcursor } from "./Dropcursor.js";
import { HardBreak } from "./HardBreak.js";
import { Heading } from "./Heading.js";
import { Highlight } from "./Highlight.js";
import { History } from "./History.js";
import { Italic } from "./Italic.js";
import { Link } from "./Link/Link.js";
import { ListItem } from "./ListItem.js";
import { LiteralTab } from "./LiteralTab.js";
import { Paragraph } from "./Paragraph.js";
import { Strike } from "./Strike.js";
import { Text } from "./Text.js";
import { TextAlign } from "./TextAlign.js";
import { TextStyle } from "./TextStyle.js";
import { TransformerHTML } from "./TransformerHTML.js";
import { TransformerJSONObject } from "./TransformerJSONObject.js";
import { TransformerJSONString } from "./TransformerJSONString.js";
import { TransformerMarkdown } from "./TransformerMarkdown.js";
import { Underline } from "./Underline.js";
var starterPack = [
  [Document, Text, TextStyle, HardBreak, Dropcursor, Color, LiteralTab, ListItem, Paragraph(), BulletList],
  [TransformerHTML, TransformerJSONObject, TransformerJSONString, TransformerMarkdown],
  [Bold, Italic, Underline, Strike, TextAlign, CodeBlock],
  [Link],
  [Heading],
  [Highlight],
  [Spacer],
  [History]
];
export {
  starterPack
};
